<template>
  <div class="mt-10 relative flex flex-col gap-y-2 py-2 px-3 bg-primary bg-opacity-10 dark:bg-blue-dark dark:bg-opacity-40 rounded">
    <p class="text-[15px] text-black dark:text-white font-semibold pr-24">
      Наш Telegram канал</p>
    <p class="text-black dark:text-white text-[11px] pr-24">
      Отзывы, розыгрыши, новости, общение
    </p>
    <a
        target="_blank"
        href="https://t.me/geekstore"
        class="bg-primary py-2 px-3 min-w-[215px] mr-24 text-white text-[13px] font-semibold rounded"
        @click="trackTelegramChannelClick"
    >Перейти</a
    ><img src="../assets/img/tg.png" class="absolute -top-4 right-0 w-[98px]" draggable="false" />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useYandexMetrika } from 'yandex-metrika-vue3'

const yandexMetrika = useYandexMetrika()
const isShow = ref(false);

const trackTelegramChannelClick = () => {
    yandexMetrika.reachGoal('TG_CHANNEL_CLICK');
}
</script>

<style>
.side-banner_telegram {
  background: #121729;
  border: 2px solid #229ED9;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  margin-top: 44px;
  padding: 20px;
  position: relative;
  gap: 12px;
}
.side-banner_title {
  color: #fff;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin: 0;
  max-width: 187px;
  text-align: left;
}
.side-banner_text p {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  margin: 0;
}
.side-banner_img {
  width: 55px;
  height: 53px;
  position: absolute;
  top: -20px;
  right: -20px;
  object-fit: contain;
}
.side-banner_btn {
  background: #229ED9;
  color:white;
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  margin-top: 12px;
  padding: 10px;
  width: 100%;
}
.side-banner_tooltip {
  background: #2a2e3e;
  color: #fff;
  font-size: 14px;
  left: 160px;
  line-height: 18px;
  padding: 12px 20px;
  width: 170px;
  border-radius: 8px;
  position: absolute;
  right: 0;
}
</style>
